/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImageUploadRequest
 */
export interface ImageUploadRequest {
    /**
     * 
     * @type {string}
     * @memberof ImageUploadRequest
     */
    data: string;
}

export function ImageUploadRequestFromJSON(json: any): ImageUploadRequest {
    return ImageUploadRequestFromJSONTyped(json, false);
}

export function ImageUploadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageUploadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': json['data'],
    };
}

export function ImageUploadRequestToJSON(value?: ImageUploadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}


